import React from 'react'

const Admin = () => (
	<div className='container'>Hola Administrador</div>
)

export default Admin;


// WEBPACK FOOTER //
// ./src/components/Admin/index.js